/**
 * hush.cues — the Hush Nook discovery moment. A quiet paper rustle and three
 * soft bell tones timed to the lantern's three window winks (0/300/600ms).
 * Spatial and low priority: it is a hint, never louder than combat or UI.
 */

import type { Cue } from '../engine/audioTypes';

const bell = (freq: number, delayMs: number, gain: number) => ({
  delayMs,
  // A near-flat sweep keeps the tone bell-like instead of the default drop.
  desc: { kind: 'tone' as const, freq, osc: 'sine' as const, durationMs: 420, gain, sweepTo: freq * 0.97 },
});

export const HUSH_CUES: Cue[] = [
  {
    id: 'world.hush.entrance_wink',
    bus: 'sfx',
    priority: 0.2,
    minIntervalMs: 3000,
    maxStack: 1,
    spatial: true,
    sound: {
      kind: 'sequence',
      steps: [
        { delayMs: 0, desc: { kind: 'noise', durationMs: 160, gain: 0.05, filter: { type: 'bandpass', freq: 2400 } } },
        bell(988, 0, 0.16),
        bell(1175, 300, 0.14),
        bell(880, 600, 0.18),
      ],
    },
  },
];

/** Dynamic EventBus events → Hush cue ids (payload carries x/y for spatial pan). */
export const HUSH_EVENT_CUES: Record<string, string> = {
  'hush:entranceWink': 'world.hush.entrance_wink',
};
